import PropTypes from 'prop-types';
import React from 'react';

import 'commons-forms/components/InputRadio/InputRadio.scss';

const InputRadio = ({ isRequired, isSelected, label, name, onChange, value }) => {
    const id = `${name}-${value}`;

    return (
        <div className="radio-button-cta-wrapper--single">
            <input
                type="radio"
                id={id}
                name={name}
                value={value}
                checked={isSelected}
                onChange={() => onChange(value, name)}
                required={isRequired}
            />
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

InputRadio.defaultProps = {
    isRequired: false,
    isSelected: false,
};

InputRadio.propTypes = {
    isRequired: PropTypes.bool,
    isSelected: PropTypes.bool,
    label: PropTypes.node.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
};

InputRadio.displayName = 'InputRadio';

export default InputRadio;
